// import the library
import {library} from '@fortawesome/fontawesome-svg-core';

// import your icons
import {faPaperPlane, faFile} from '@fortawesome/free-solid-svg-icons';
import {
  faGithub,
  faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons';

library.add(
  faPaperPlane,
  faFile,
  faGithub,
  faLinkedinIn
);
